/*
 * @FilePath     : /es-package/packages/es-mpx-usex/lib/env/index.web.js
 * @Author       : LiYang
 * @Date         : 2022-02-21 16:38:49
 * @LastEditTime : 2022-02-21 21:46:39
 * @LastEditors  : Please set LastEditors
 * @Description  : 
 */


const PRE_REG = /(?:\/pre-release-)(\w+)/
export default () => {
  let env = window.location.pathname.match(PRE_REG)
  if (env) {
    env = parseInt(env[1], 10)
  }
  return Promise.resolve(env || '-1')
}